import { useNode } from "@craftjs/core";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";

import { BlockBackground, Wrapper } from "./divider-component-styles";

export type DividerProps = {
  children: React.ReactNode;
};

export default function Divider(props: DividerProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackground ref={connect} id={nodeId}>
      <BlockMaxWidthWrapper>
        <Wrapper>{props.children}</Wrapper>
      </BlockMaxWidthWrapper>
    </BlockBackground>
  );
}

Divider.craft = {
  isCanvas: true,
  custom: {
    displayName: "Divider",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
